import type { InjectionKey } from 'vue'

import type { useWebsitePublish } from '@/composables/useWebsitePublish'

export const websitePublishKey = Symbol('websitePublish') as InjectionKey<
  ReturnType<typeof useWebsitePublish>
>
